import { createFileRoute, redirect } from '@tanstack/react-router'
import z from 'zod'

import { sofaTypes } from '@sofa-platform/range-data-generator/type-object'

import { DocumentTitleWithCurrentSofa } from '@/components/document-title'
import { SceneLayout } from '@/components/scene-layout'
import { usePlannerMode } from '@/hooks/use-planner-mode'

const pathParamsSchema = z.object({
  country: z.string().length(2),
  language: z.string().length(2),
  rangeId: z.enum([...Object.keys(sofaTypes), 'future'], 'Invalid rangeId'),
})

export const Route = createFileRoute('/$country/$language/planner/$rangeId')({
  params: {
    parse: (rawParams) => pathParamsSchema.parse(rawParams),
  },
  component: SceneRoute,
  beforeLoad: ({ params }) => {
    // Adding as a safeguard to prevent users from accessing the planner mode in non-production environments.
    // This should be removed once the planner mode is fully implemented and ready for testing in non-production environments.
    if (import.meta.env.MODE === 'production') {
      throw redirect({
        to: '/$country/$language/navigator',
        params: {
          country: params.country,
          language: params.language,
        },
        replace: true,
      })
    }
  },
  loaderDeps: ({ search: { origin, ipexGallery } }) => ({
    origin,
    ipexGallery,
  }),
})

function SceneRoute() {
  usePlannerMode()

  return (
    <>
      <DocumentTitleWithCurrentSofa />
      <SceneLayout backTo="/$country/$language/planner" defaultSidebarView="planner" />
    </>
  )
}
